import { type MouseEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '@/pages/Home/Home.module.scss';

const SCROLL_HINT_HIDE_THRESHOLD = 50;

const scrollTo = (id: string) => (e: MouseEvent) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const Home = () => {
  const { t } = useTranslation();
  const [hintVisible, setHintVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setHintVisible(window.scrollY <= SCROLL_HINT_HIDE_THRESHOLD);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={styles.hero}>
      <div className={styles.content}>
        <p className={styles.tagline}>{t('home.tagline')}</p>
        <h1 className={styles.heading}>
          {t('home.heading.before')} <span className={styles.headingHighlight}>{t('home.heading.highlight')}</span>{' '}
          {t('home.heading.after')}
        </h1>
        <p className={styles.perex}>{t('home.perex')}</p>
        <div className={styles.cta}>
          <a href='#work' className={styles.ctaPrimary} onClick={scrollTo('work')}>
            {t('home.cta.projects')}
          </a>
          <a href='#contact' className={styles.ctaSecondary} onClick={scrollTo('contact')}>
            {t('home.cta.contact')}
          </a>
        </div>
      </div>
      <div className={`${styles.scrollHint}${hintVisible ? '' : ` ${styles.hidden}`}`} aria-hidden='true'>
        <div className={styles.mouse}>
          <span className={styles.wheel} />
        </div>
      </div>
    </div>
  );
};

export default Home;
